import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesModule } from 'angular-datatables/src/angular-datatables.module';
import { Subject } from 'rxjs';
import { AttendanceService } from '../../../Model/Attendance/attendance.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-attendance-policies',
  standalone: true,
  imports: [CommonModule,RouterOutlet,RouterModule,DataTablesModule,LoaderComponent],
  templateUrl: './attendance-policies.component.html',
  styleUrl: './attendance-policies.component.scss'
})
export class AttendancePoliciesComponent {
  isDisabled: boolean = false;
  AttendenceData :  any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private attendance: AttendanceService,
    protected common: CommonService,
    private tooltip : TooltipService,
    private download : DownloadSampleService,
    private toast :  ToastService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.AttendanceRuleLoadGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  AttendanceRuleLoadGet() {
    this.isDisabled = true;
    this.attendance.AttendanceRuleLoadGet({ SelectType: 1, ESS_AttendanceRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'AttendancePolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.AttendenceData = data;
        if( this.AttendenceData.length > 0){
          this.download.exportToExcel(this.AttendenceData, "AttendencePolicies_data");
          this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }     
      });
  }
}
